export default function NotificationIcon() {
  return (
    <svg
      width="19"
      height="21"
      viewBox="0 0 19 21"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.6"
        d="M9.12362 0.0923215C4.91347 0.290623 1.6875 3.90785 1.6875 8.09403V11.8792L0.307089 14.6563C0.304661 14.6614 0.302287 14.6665 0.299968 14.6716C-0.255374 15.8526 0.643598 17.2707 1.94893 17.2707H6.375C6.375 18.9873 7.7834 20.3957 9.5 20.3957C11.2166 20.3957 12.625 18.9873 12.625 17.2707H17.05C18.3554 17.2707 19.2555 15.8529 18.7 14.6716C18.6977 14.6665 18.6953 14.6614 18.6929 14.6563L17.3125 11.8792V7.89567C17.3125 3.46535 13.5955 -0.118207 9.12362 0.0923215ZM9.19686 1.65279C12.8011 1.48311 15.75 4.33431 15.75 7.89567V12.0623C15.7499 12.183 15.7777 12.3021 15.8314 12.4102L17.2861 15.3379C17.3796 15.5384 17.2714 15.7082 17.05 15.7082H1.94893C1.72762 15.7082 1.62026 15.5387 1.71395 15.3379V15.3369L3.16862 12.4102C3.22225 12.3021 3.25011 12.183 3.25 12.0623V8.09403C3.25 4.70834 5.84346 1.81074 9.19686 1.65279ZM7.9375 17.2707H11.0625C11.0625 18.1426 10.3719 18.8332 9.5 18.8332C8.62806 18.8332 7.9375 18.1426 7.9375 17.2707Z"
        fill="currentColor"
      />
    </svg>
  );
}
